import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .label {
    font-size: 14px;
    padding: 4px;
    border-radius: 2px;
  }

  .marker-line {
    width: 6px;
    height: 6px;
    border-width: 3px;
  }

  .marker-dot {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: relative;
  }

  .marker-white {
    position: absolute;
    top: 5px;
    left: 5px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${ ({ theme }) => theme.colors.white }
  }
`